<template>
  <div class="exr-item">
    <audio :src="getFileUrl(value.audio)" controls style="flex: 1;width: 100%;"></audio>
  </div>
</template>

<script>
import utils from "@/js/utils.js";

export default {
  name: "PdtItemAudio",
  props: {
    value: Object,
  },
  methods: {
    getFileUrl(file) {
      return utils.url(file)
    }
  }
}
</script>